// extracted by mini-css-extract-plugin
module.exports = {"invalid":"PostalCodeInput-module__invalid___2O7-5"};